import { useEffect, useState } from 'react'
import { useIsFeatureEnabled } from './FeatureTogglesProvider'
import { DEFAULT_FEATURE_TOGGLE_VALUES, FEATURE_TOGGLES } from './utils'

const ADS_ENABLED_FEATURE_FLAG = FEATURE_TOGGLES.adsEnabled

const useIsAdsEnabled = (): {
  isAdsEnabled: boolean
  isLoading: boolean
} => {
  const isFeatureEnabled = useIsFeatureEnabled(ADS_ENABLED_FEATURE_FLAG)
  const [isAdsEnabled, setIsAdsEnabled] = useState<boolean>(
    Boolean(DEFAULT_FEATURE_TOGGLE_VALUES[ADS_ENABLED_FEATURE_FLAG])
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    isFeatureEnabled()
      .then((value) => {
        setIsAdsEnabled(Boolean(value))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return { isAdsEnabled, isLoading }
}

export default useIsAdsEnabled
